import { createAction } from "@ngrx/store";
import { Deal } from "../../shared/models/deal.model";
import { httpError, payload } from "../shared/utils/ngrx-creators";

export const logout = createAction('[Auth] Logout');
